module.exports = __webpack_public_path__ + "img/superpowers_jp.3078073.jpg";